/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SysOrg } from '../models/SysOrg';
import type { SysOrgImportOptionsDto } from '../models/SysOrgImportOptionsDto';
import type { SysOrgImportResultDto } from '../models/SysOrgImportResultDto';
import type { SysOrgInfoDto } from '../models/SysOrgInfoDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SysOrgService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns SysOrg OK
     * @throws ApiError
     */
    public getOrgs(): CancelablePromise<Array<SysOrg>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/SysOrg/GetOrgs',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param orgGuid
     * @returns SysOrgInfoDto OK
     * @throws ApiError
     */
    public getSysOrgInfo(
        orgGuid: string,
    ): CancelablePromise<SysOrgInfoDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/SysOrg/{orgGuid}/GetSysOrgInfo',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param orgGuid
     * @param requestBody
     * @returns SysOrg OK
     * @throws ApiError
     */
    public updateSysOrg(
        orgGuid: string,
        requestBody?: SysOrg,
    ): CancelablePromise<SysOrg> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/SysOrg/{orgGuid}/UpdateSysOrg',
            path: {
                'orgGuid': orgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param sysOrgGuid
     * @returns any OK
     * @throws ApiError
     */
    public joinSysOrg(
        sysOrgGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/SysOrg/{sysOrgGuid}/JoinSysOrg',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns SysOrg OK
     * @throws ApiError
     */
    public createSysOrg(
        requestBody?: SysOrg,
    ): CancelablePromise<SysOrg> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/SysOrg/CreateSysOrg',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param sysOrgGuid
     * @returns any OK
     * @throws ApiError
     */
    public deleteSysOrg(
        sysOrgGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/SysOrg/{sysOrgGuid}/DeleteSysOrg',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param sysOrgGuid
     * @returns any OK
     * @throws ApiError
     */
    public exportSysOrgAsJson(
        sysOrgGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/SysOrg/{sysOrgGuid}/ExportSysOrgAsJson',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns SysOrgImportResultDto OK
     * @throws ApiError
     */
    public importSysOrgFromJson(
        requestBody?: SysOrgImportOptionsDto,
    ): CancelablePromise<SysOrgImportResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/SysOrg/ImportSysOrgFromJson',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
